import {EmojiDictionary} from "./@type";
import {EmojiIconConfig} from "./config";

// this is a main config we use to generate emoji DICT

// make sure it runs only one time (!)
const generateEmojiDictionary = () : EmojiDictionary => {

    const result: EmojiDictionary = {}

    EmojiIconConfig.forEach(emoji => {

        result[emoji.name] = {
            name        : emoji.name,
            symbol      : emoji.symbol,
            keyword     : emoji.keyword || emoji.name,
            versions    : emoji.versions
        }
    })

    return result
}

export const EmojiDict : EmojiDictionary = generateEmojiDictionary()
